export default __webpack_public_path__ + "static/media/engrace5.36efb7bd.webp";